// extracted by mini-css-extract-plugin
export default {"root":"root_root__g12cL","footer":"root_footer__bZFUv"};